module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "boxg"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004_Preface#fm-1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Introduction#fm-2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Part01#pt-1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("PART ONE")])]), _vm._v(": Politics vs. Economics in Public Finance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#ch-1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 1:")])]), _vm._v(" What Happens When Local Politics Win?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#ch-2"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 2:")])]), _vm._v(" Who Cares about Ratepayers?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 3:")])]), _vm._v(" Which City Gets a Minor League Team?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("PART TWO:")])]), _vm._v(" Schemes and Scams in Public Finance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 4:")])]), _vm._v(" Who Are the Bad Guys?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 5:")])]), _vm._v(" How New Is Shady Tax Structuring?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 6:")])]), _vm._v(" How Is Political Power Exercised?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 7:")])]), _vm._v(" Officious Interference and Shady Claims")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("PART THREE:")])]), _vm._v(" Overview of Municipal Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 8:")])]), _vm._v(" Why a Public Authority?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 9:")])]), _vm._v(" What Is a Second Injury Fund?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 10:")])]), _vm._v(" Public Finance Tidbits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 11:")])]), _vm._v(" What Is the Tenth Amendment?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 12:")])]), _vm._v(" What Is Arbitrage?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 13:")])]), _vm._v(" What Is Bond Disclosure?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 14:")])]), _vm._v(" What Is Venture Capital?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 15:")])]), _vm._v(" What’s “In the State” versus “Of the State”?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('strong', [_vm._v("CHAPTER 16:")])]), _vm._v(" What about Public Financing in Eastern Europe?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/025_About_the_Author#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Acknowledgments#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Appendix_A#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Appendix_B#bm-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Appendix_C#bm-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Appendix_D#bm-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Endnotes#bm-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5286f690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Contents.vue
// module id = 63
// module chunks = 0